import { AssignmentModel, TransportAssignmentModel } from 'api/model';
import React, { useMemo } from 'react';
import { LabelTextButton } from './style';
import Routes from 'constants/Routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarAlt, faWarning } from '@fortawesome/free-solid-svg-icons';
import TooltipInfo from 'components/TooltipInfo';
import useTranslations from 'contexts/basicData/useTranslations';

interface Props {
  mainAssignment: AssignmentModel;
  loadedAssignment: TransportAssignmentModel;
}

const LoadedCarButton: React.FC<Props> = ({
  mainAssignment,
  loadedAssignment,
}) => {
  const { loadingStatuses } = useTranslations();
  const hasSameRouteAsParent = useMemo(() => {
    // return true if loadedAssignment from and to address details match the mainAssignment

    const fromAddressString = `${loadedAssignment.fromAddress} ${loadedAssignment.fromCity} ${loadedAssignment.fromZip}`;
    const toAddressString = `${loadedAssignment.toAddress} ${loadedAssignment.toCity} ${loadedAssignment.toZip}`;

    const mainFromAddressString = `${mainAssignment.fromAddress} ${mainAssignment.fromCity} ${mainAssignment.fromZip}`;
    const mainToAddressString = `${mainAssignment.toAddress} ${mainAssignment.toCity} ${mainAssignment.toZip}`;
    return (
      fromAddressString === mainFromAddressString &&
      toAddressString === mainToAddressString
    );
  }, [mainAssignment, loadedAssignment]);
  return (
    <LabelTextButton
      onClick={() =>
        window.open(
          `${Routes.search.index}/${loadedAssignment.loadedAssignmentCaseID}`,
          loadedAssignment.caseRegistrationNumber ?? '_blank'
        )
      }
      title={`Tilldelad bil ${loadedAssignment.caseRegistrationNumber}`}
    >
      {loadedAssignment.caseRegistrationNumber}{' '}
      <FontAwesomeIcon icon={faCarAlt} />
      {loadingStatuses[loadedAssignment.loadingStatus]}
      {!hasSameRouteAsParent && (
        <TooltipInfo
          icon={faWarning}
          redWarning
          hoverable
          info={
            <span>
              Denna bil har en annan rutt än huvuduppdraget. Kontrollera att den
              är korrekt.
            </span>
          }
        />
      )}
    </LabelTextButton>
  );
};

export default LoadedCarButton;
